<template>
 <div>
    <page-header title="Earnings" breadcrumb="Billings & Payments > Earnings" />
    <div class="flex justify-between mt-12 tabs-bg">
      <div class="flex">
        <div class="tab-item" :class="{ active: currentTab == 'overview', inactive: currentTab != 'overview'}" @click="currentTab = 'overview'">
          <p>Overview</p>
        </div>
   
        <div class="tab-item" :class="{ active: currentTab == 'earnings', inactive: currentTab != 'earnings' }" @click="currentTab = 'earnings'">
          <p>Earnings</p>
        </div>
      </div>
      
    </div>
    <div class="bg-white"><hr /></div>
    

    <component :is="currentTab"></component>

  </div>
</template>

<script>

import PageHeader from "@/components/UI/NewPageHeader";
import Overview from "@/components/3pl/Billings/EarnAndPayment/Overview";
import Earnings from "@/components/3pl/Billings/EarnAndPayment/Earnings";


export default {
  components: {
    PageHeader,
    Overview ,
    Earnings,
  },
  data() {
    return {
     currentTab: "overview",
      query: '',
      count: {},
      sortList: false  
    };
  },
  watch: {
      currentTab(val) {
      this.$store.dispatch("setCurrentOverviewTab", val);
    },
    query(val) {
      this.$store.dispatch("setOverviewQuery", val);
    },
    sortList() {
      this.$store.dispatch("setOverviewSortList", this.sortList);
    }
  },
  mounted() { 
    this.$store.dispatch("setOverviewQuery", "");

    if (this.$route.query.tab) {
      this.currentTab = this.$route.query.tab;
    } else {
      const currentTab = this.$store.getters.currentOverviewTab;
      this.currentTab = currentTab || "overview";
    }
  },
  
}
</script>

<style lang="scss" scoped>
.tabs-bg{
  background-color: #FFFFFF;
  padding-top: 4%;
  padding-left: 2%;
}
hr{
  border: 1px solid #C2C7D6;
  width: 96%;
  margin: 0 auto;
}
.tab-item {
  cursor: pointer;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #FCC210;
    font-weight: bold;
  }
   &.inactive{
    background: #7B858F1A;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #9BA0A7;
   }
}
</style>
